if (document.getElementById("job")) {
    var job_page = document.getElementById("job");
    var id = job_page.dataset.id;

    var request = new XMLHttpRequest();
    request.open("GET", `https://www.clbnetwork.com/data/${id}.json`, true);
    request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
            var data = JSON.parse(request.responseText);
            buildJobPage(data);
        } else {
        }
    };

    request.onerror = function () {
        // There was a connection error of some sort
    };

    request.send();

    function buildJobPage(data) {
        var page_title = document.getElementsByTagName("title");
        var heading = document.getElementsByTagName("h1");
        var description = document.getElementById("job_description");
        var position_input = document.querySelector(
            'input[value="Loading Position Name..."]'
        );

        page_title[0].innerText = data.title + " " + data.macro_address;
        heading[0].innerText = `${data.title}`;
        description.innerHTML = `${data.description}`;
        position_input.setAttribute("value", data.title);
    }
}
